import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {Store, StoreState} from './store';

@Injectable({ providedIn: 'root' })
export class StoreQuery extends QueryEntity<StoreState> {

  constructor(protected store: Store) {
    super(store);
  }

}
